import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_REGISTER_GST_STATE,
  CLOSE_BSB_NOTICE,
} from './constants';

import {
  GET_BANK_SUCCESS,
  GETTING_BANK,
  GET_BANK_ERROR,
} from '../../FastCover/constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    abn: '',
    claimITC: 'false',
    nameOfBank: '',
    branch: '',
    bsbNumber: '',
    institutionNumber: '',
    accountNumber: '',
    accountHolder: '',
    registerForGSTPurpose: 'false',
    percentageOfGST: '',
    bsbCannotBeVerified: false,
    isBsbValid: false,
    otherInsurance: 'false',
    provideDetails: '',
  },
  errors: [],
  dirty: false,
  bsbValidating: false,
  showBSBNotice: false,
});

const initialRegisterForGstState = {
  form: {
    registerForGSTPurpose: 'false',
    abn: '',
    claimITC: 'false',
    percentageOfGST: '',
  },
};

const initialBankInfo = {
  form: {
    nameOfBank: '',
    branch: '',
    institutionNumber: '',
  },
};

function stepAppsureBankDetailsReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      if (properties[1] === 'bsbCannotBeVerified' && !action.value) {
        return state.mergeDeep(initialBankInfo).setIn(properties, action.value);
      }
      return state.setIn(properties, action.value);
    case LOAD:
      if (action.payload) {
        return fromJS({ form: action.payload, errors: [] });
      }
      return initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_REGISTER_GST_STATE:
      return state.mergeDeep(initialRegisterForGstState);
    case GET_BANK_SUCCESS:
      return state.mergeDeep({ form: action.bankInfo, bsbValidating: false });
    case GETTING_BANK:
      return state.merge({ bsbValidating: action.value });
    case GET_BANK_ERROR:
      return state.merge({ showBSBNotice: true });
    case CLOSE_BSB_NOTICE:
      return state.merge({ showBSBNotice: false });
    default:
      return state;
  }
}

export default stepAppsureBankDetailsReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Appsure.StepBankDetails/reducer.js